import { effectiveSiteName } from '@pokerroom/branding';
import { brand } from '../lib/brand';
/**
 * @hook useSiteName
 * @description Returns the custom site name from system settings, fallback to the build brand.
 * Works on all pages including public ones (settings/:key is public).
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useSiteName(): string {
  const { data } = useQuery<{ key: string; value: string } | null>({
    queryKey: ['settings', 'site_name'],
    queryFn: async () => {
      try {
        return await api.get<{ key: string; value: string }>('/settings/site_name');
      } catch {
        return null;
      }
    },
    staleTime: 5 * 60 * 1000,
  });

  return effectiveSiteName(brand, data?.value);
}
